import { ref, onMounted, onUnmounted } from 'vue';
import router from '@/router';
import { NAV_ITEMS } from '../config/navigation';
import { NavItem } from '../types/navigation';

export function useNavigation() {
  const isMenuOpen = ref(false);
  const isScrolled = ref(false);
  const activeItem = ref<NavItem | null>(null);

  const handleScroll = () => {
    isScrolled.value = window.scrollY > 0;
  };

  const toggleMenu = () => {
    isMenuOpen.value = !isMenuOpen.value;
  };

  const closeMenu = () => {
    isMenuOpen.value = false;
  };

  const findNavItem = (navName: string): NavItem | undefined => {
    return NAV_ITEMS.find(item => 
      item.name?.toLowerCase() === navName.toLowerCase() || 
      item.label.toLowerCase() === navName.toLowerCase()
    );
  };

  const goTo = (routeName: string) => {
    const matchedNavItem = findNavItem(routeName);
    if (matchedNavItem) {
      router.push(matchedNavItem.to);
    }
  };

  const loadHome = () => {
    if (window.location.pathname === '/') {
      window.location.href = '/';
      return;
    }
    router.push('/');
  };

  const setActiveItem = (item: NavItem) => {
    activeItem.value = item;
  };

  onMounted(() => {
    window.addEventListener('scroll', handleScroll);
    handleScroll();
  });

  onUnmounted(() => {
    window.removeEventListener('scroll', handleScroll);
  });

  return {
    isMenuOpen,
    isScrolled,
    activeItem,
    setActiveItem,
    toggleMenu,
    closeMenu,
    loadHome,
    goTo,
    findNavItem,
    navItems: NAV_ITEMS
  };
}